import { navigation } from './navigation.js';
import { hashScroll } from './hashScroll.js';
import { googleMaps } from './googleMaps.js';

navigation();
hashScroll();
googleMaps();
